import { useCallback, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { LandingPageSectionsContainer } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/theming-landing-page-tab-container/landing-page-sections-container/landing-page-sections-container";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { PageLevelTypes } from "@enums/page-level-types";
import { RedirectUrlInformation } from "@idw-types/redirect-url-information";
import { resources } from "@constants/hardcoded-strings";
import { RedirectUrlOriginTypes } from "@enums/redirect-url-origin-types";
import { WorkflowGeneralBasicInfoValidationErrors } from "@idw-types/common/validation/workflow-details-validation-errors";

type WorkflowRedirectUrlContainerProps = {
    isDisabled: boolean;
    pageLevel: PageLevelTypes;
    redirectUrlsInformation: RedirectUrlInformation;
     validationErrors: WorkflowGeneralBasicInfoValidationErrors;
    handleRemoveRedirect: (index: number, redirectURLOrigin: RedirectUrlOriginTypes) => void;
    handleAddRedirect: (newRedirectUrl: string) => void;
    handleRedirectChangeAtIndex: (newRedirectUrl: string, index: number, redirectUrl: string, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
}

export const WorkflowRedirectUrlContainer = (props: WorkflowRedirectUrlContainerProps) => {
    const {
        isDisabled,
        pageLevel,
        validationErrors,
        redirectUrlsInformation,
        handleAddRedirect,
        handleRemoveRedirect,
        handleRedirectChangeAtIndex
    } = props;

    const [showOriginBadge, setShowOriginBadge] = useState(false);

    const handleHotKeyPressed = useCallback(() => {
        setShowOriginBadge(prevShowOriginBadge => !prevShowOriginBadge)
    }, [showOriginBadge]);

    useHotkeys("ctrl+shift+u, command+shift+u", handleHotKeyPressed);

    return (
        <div>
            <ContentPageHeader title={resources.pages.verificationServiceDetails.tabs.general.subTabs.basicInfo.inputs.redirectUrls.label} />
            <ContentPageBody isMaxWidth={true}>
                {validationErrors.redirectUrlError}
                <LandingPageSectionsContainer
                    isDisabled={isDisabled}
                    isTheming={false}
                    showOriginBadge={showOriginBadge}
                    validationErrors={null}
                    axnuiContent={null}
                    axnuiLayout={null}
                    inheritedAXNUIContent={null}
                    inheritedAXNUILayout={null}
                    pageLevel={pageLevel}
                    redirectUrlsInformation={redirectUrlsInformation}
                    handleRemoveRedirect={handleRemoveRedirect}
                    handleAddRedirect={handleAddRedirect}
                    handleRedirectChangeAtIndex={handleRedirectChangeAtIndex}
                    updateAXNUIContentPropertyValue={()=>{}}
                    updateAXNUILayoutPropertyValue={()=>{}}
                />
            </ContentPageBody>
        </div>
    );
}